import { useEditStore } from '../../hooks';
import { ApiKeyTemplateRegistrationModalView } from '../../components/ApiKeyTemplateRegistrationModalView';

export const ApiKeyTemplateEditModal = () => {
  const editStore = useEditStore();

  return <ApiKeyTemplateRegistrationModalView {...editStore} />;
};
